import axios from 'axios'
import { getCookie } from '@/utils/cookies'
//添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 将token给到一个前后台约定好的key中，作为请求发送
  let token = getCookie('myToken');
  config.headers = {
    'authorization': token,
    'Content-Type': 'application/json',
    'timestamp': '',
    'version': '',
    'client': 'protal',
    'terminal':'Web/App',
    'x-api-version': '1.0.0'
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

//添加响应拦截器
axios.interceptors.response.use(response => {
  // 对响应数据做些事
  // let token = sessionStorage.getItem('myToken');
  // if(token){
  // store.commit('closeLoading');
  // }
  // if(response.data.code == "SYS2003" || response.data.code == "GW1000"){
  //     sessionStorage.clear()

  // }
  return response;
}, error => {
  // 请求错误时做些事
  // console.log(error)
  if (error.response) {
    // switch (error.response.status) {
    //   case 404:
    //   // 返回 401 清除token信息并跳转到登录页面
    //   MessageBox.alert('您的数据异常，请联系管理员', {
    //       confirmButtonText: '确定',
    //       showClose:false,
    //       callback: action => {
    //           sessionStorage.clear()

    //       }
    //   });
    //   // router.replace({
    //   //   path: 'login',
    //   //   query: {redirect: router.currentRoute.fullPath} // 登录成功后跳入浏览的当前页面
    //   // })
    //   break;
    // }
  }
  return Promise.reject(error.response); // 返回接口返回的错误信息
});



// WEBPACK FOOTER //
// ./src/api/http.js